import React, { useState, useEffect, useRef } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import { getNotificationProfilePhoto } from "../../utils/profilePhotoUtils";
import { Col, Nav, NavItem, NavLink, Row, Input } from 'reactstrap';
import classnames from 'classnames';
// 在顶部导入语句添加  
//import images
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar8 from "../../assets/images/users/avatar-8.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";
import bell from "../../assets/images/svg/bell.svg";
import { ToastContainer, toast } from 'react-toastify';

import {  baseURL } from '../../utils/usermanagement';

import { fenchNotifications,submitApproval } from '../../utils/message';
import EventBus from '../../utils/eventBus'; // 引入 EventBus
const NotificationDropdown = () => {
    // Timestamp formatting function
    const formatTimestamp = (timestamp) => {
        if (!timestamp) return "";
        try {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        } catch (error) {
            console.error("Error formatting timestamp:", error);
            return timestamp;
        }
    };

    // Date range formatting function for todo items
    const formatDateRange = (startDate, endDate) => {
        if (!startDate || !endDate) return "";
        try {
            const start = new Date(startDate);
            const end = new Date(endDate);
            
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };
            
            const startFormatted = formatDate(start);
            const endFormatted = formatDate(end);
            
            // If same date, show only one date
            if (startFormatted === endFormatted) {
                return startFormatted;
            }
            
            return `${startFormatted} - ${endFormatted}`;
        } catch (error) {
            console.error("Error formatting date range:", error);
            return `${startDate} - ${endDate}`;
        }
    };

    //Dropdown Toggle
    const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
    const toggleNotificationDropdown = () => {
        setIsNotificationDropdown(!isNotificationDropdown);
    };
    useEffect(() => { 
        loadMessageData();
        loadTodoList();
    }, []);
    const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
    useEffect(() => {
        const handleMessageRefresh = () => {  
            loadMessageData();
        };
    
        // 订阅事件
        EventBus.subscribe('refreshMessage', handleMessageRefresh);
    
        // 组件卸载时取消订阅
        return () => {
        EventBus.unsubscribe('refreshMessage', handleMessageRefresh);
        };
    }, []);
    const [notifications,setIsNotifications] = useState([]);
    const [todoList,setTodoList] = useState([]);
    const loadMessageData = async () => {
        try { 
          const response = await fenchNotifications();  
           
          if (response.status === 200){ 
            console.log(response.data) 
            setIsNotifications(response.data); 
          }
          else{
            errornotify(response.message)
          }
        } catch (error) {
          console.error("Error loading messages:", error);
        } finally {
          // setLoading(false);
        }
    }; 
    const loadTodoList = async () => {
        // try { 
        //   const response = await fenchTodoList();  
           
        //   if (response.status === 200){ 
        //     console.log(response.data) 
        //     setTodoList(response.data);  
        //   }
        //   else{ 
        //     errornotify(response.message)
        //   }
        // } catch (error) {
        //   console.error("Error loading messages:", error);
        // } finally {
        //   // setLoading(false);
        // }
        const todoList =[
            {id:1,time_type:"Leave Approval",description:"Leave Approval",status:"Pending",start_time:"2024-06-01",end_time:"2024-06-01",user_name:"John Doe",supporting_document:""}, 
            {id:2,time_type:"Sick Off",description:"Leave Approval",status:"Pending",start_time:"2024-06-01",end_time:"2024-06-01",user_name:"John Doe",supporting_document:""},
            {id:3,time_type:"Leave Approval",description:"Leave Approval",status:"Pending",start_time:"2024-06-01",end_time:"2024-06-01",user_name:"John Doe",supporting_document:""},
            {id:4,time_type:"Leave Approval",description:"Leave Approval",status:"Pending",start_time:"2024-06-01",end_time:"2024-06-01",user_name:"John Doe",supporting_document:""},
        ]
        setTodoList(todoList);
    }; 
    //Tab 
    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [selectedTodo, setSelectedTodo] = useState(null);
    const [approveOpinion, setApproveOpinion] = useState('Approve');
    const [comment, setComment] = useState('');
    const handleSubmitApproval = async () => {
        try {
            const response = await submitApproval({
                id: selectedTodo.id,
                status: approveOpinion,
                comment
            });
            
            if (response.status === 200) {
                setShowApproveModal(false);
                loadTodoList(); // 刷新待办列表
                EventBus.dispatch("refreshMessage"); // 刷新消息列表
            } else {
                errornotify(response.message);
            }
        } catch (error) {
            console.error("审批提交失败:", error);
            errornotify("审批提交失败");
        }
    };
    
    return (
        <React.Fragment>
            <Dropdown isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown} className="topbar-head-dropdown ms-1 header-item">
                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                    <i className='bx bx-bell fs-22'></i>
                    <span
                        className="position-absolute topbar-badge translate-middle badge rounded-pill bg-danger">{notifications.length}<span
                            className="visually-hidden">unread messages</span></span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                    <div className="dropdown-head bg-primary bg-pattern rounded-top">
                        <div className="p-3">
                            <Row className="align-items-center">
                                <Col>
                                    <h6 className="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
                                </Col>
                                <div className="col-auto dropdown-tabs">
                                    <span className="badge bg-light-subtle text-body fs-13"> {notifications.length} New</span>
                                </div>
                            </Row>
                        </div>

                        <div className="px-2 pt-2">
                            <Nav className="nav-tabs dropdown-tabs nav-tabs-custom"> 
                                <NavItem>
                                    <NavLink
                                        href="#"
                                        className={classnames({ active: activeTab === '1' })}
                                        onClick={() => { toggleTab('1'); }}
                                    >
                                        Messages
                                    </NavLink>
                                </NavItem>
                                {/* <NavItem>
                                    <NavLink
                                        href="#"
                                        className={classnames({ active: activeTab === '2' })}
                                        onClick={() => { toggleTab('2'); }}
                                    >
                                        Alerts
                                    </NavLink>
                                </NavItem> */}
                                <NavItem>
                                    <NavLink
                                        href="#"
                                        className={classnames({ active: activeTab === '3' })}
                                        onClick={() => { toggleTab('3'); }}
                                    >
                                        To Do
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>

                    </div>

                    <TabContent activeTab={activeTab}>  
                        <TabPane tabId="1" className="py-2 ps-2">
                            <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                                {/* <div className="my-3 text-center">
                                    <button type="button" className="btn btn-soft-success waves-effect waves-light">View
                                        All Messages <i className="ri-arrow-right-line align-middle"></i></button>
                                </div> */}
                                {notifications?notifications.map((item, index) => (
                                    <div key={item.id || index} className="text-reset notification-item d-block dropdown-item">
                                        <div className="d-flex">
                                            {(() => {
                                                const profilePhoto = getNotificationProfilePhoto(item);
                                                if (profilePhoto) {
                                                    return <img src={profilePhoto} className="me-3 rounded-circle avatar-xs" alt="user-pic" />;
                                                } else if (item.name) {
                                                    return (
                                                        <div className="me-3 rounded-circle avatar-xs bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: "24px", height: "24px", fontSize: "12px" }}>
                                                            {item.name.charAt(0).toUpperCase()}
                                                        </div>
                                                    );
                                                } else {
                                                    return <img src={`${baseURL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`} className="me-3 rounded-circle avatar-xs" alt="user-pic" />;
                                                }
                                            })()}
                                            <div className="flex-grow-1"> 
                                                <div className="fs-13 text-muted">
                                                    <Link to="/chat" className="text-reset">
                                                        {item.message}
                                                    </Link>
                                                </div>
                                                <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                    <span><i className="mdi mdi-clock-outline"></i> {formatTimestamp(item.timestamp)}</span>
                                                </p> 
                                            </div>
                                        </div>
                                    </div>
                                )):""}
 
                               
                            </SimpleBar>
                        </TabPane>
                        <TabPane tabId="2" className="p-4">
                            <div className="w-25 w-sm-50 pt-3 mx-auto">
                                <img src={bell} className="img-fluid" alt="user-pic" />
                            </div>
                            <div className="text-center pb-5 mt-2">
                                <h6 className="fs-18 fw-semibold lh-base">Hey! You have no any notifications </h6>
                            </div>
                        </TabPane>
                        <TabPane tabId="3" className="py-2 ps-2">
                            <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                                {todoList&&todoList.length>0?todoList.map((item, index) => ( 
                                    <div key={item.id || index} className="text-reset notification-item d-block dropdown-item">
                                        <div className="d-flex">
                                            {(() => {
                                                const profilePhoto = getNotificationProfilePhoto(item);
                                                if (profilePhoto) {
                                                    return <img src={profilePhoto} className="me-3 rounded-circle avatar-xs" alt="user-pic" />;
                                                } else if (item.user_name) {
                                                    return (
                                                        <div className="me-3 rounded-circle avatar-xs bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: "24px", height: "24px", fontSize: "12px" }}>
                                                            {item.user_name.charAt(0).toUpperCase()}
                                                        </div>
                                                    );
                                                } else {
                                                    return <img src={`${baseURL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`} className="me-3 rounded-circle avatar-xs" alt="user-pic" />;
                                                }
                                            })()}
                                            <div className="flex-grow-1"
                                                onClick={() => {
                                                    setSelectedTodo(item);
                                                    setShowApproveModal(true);
                                                }}> 
                                                <div className="fs-13 text-muted">
                                                    <div className="mb-1">{item.user_name}: {item.time_type}</div>
                                                    <div className="mb-1">{item.description}</div>
                                                </div>
                                                <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                    <span><i className="mdi mdi-clock-outline"></i> {formatDateRange(item.start_time, item.end_time)}</span>
                                                </p> 
                                            </div>
                                        </div>
                                    </div>
                                )): (
                                    <div className="text-center">
                                        <div className="w-25 w-sm-50 pt-3 mx-auto">
                                            <img src={bell} className="img-fluid" alt="user-pic" />
                                        </div>
                                        <div className="text-center pb-5 mt-2">
                                            <h6 className="fs-18 fw-semibold lh-base">Hey! You have no any TODO List </h6>
                                        </div>
                                    </div>
                                )}
                            </SimpleBar>
                        </TabPane>
                    </TabContent>
                </DropdownMenu>
            </Dropdown>
            <Modal isOpen={showApproveModal} toggle={() => setShowApproveModal(false)}>
                <ModalHeader toggle={() => setShowApproveModal(false)}>
                Approval Process  - {selectedTodo?.user_name}
                </ModalHeader>
                <ModalBody>
                    <div className="mb-3">
                        <label className="fw-bold">Title</label>
                        <p>{selectedTodo?.time_type}</p>
                    </div>
                    <div className="mb-3">
                        <label className="fw-bold">Description</label>
                        <p>{selectedTodo?.description}</p>
                    </div> 
                    <div className="mb-3">
                        <label className="fw-bold">Time Range</label>
                        <p>{selectedTodo?.start_time}-{selectedTodo?.end_time}</p>
                    </div>
                    <hr className="my-3" /> {/* 添加水平分割线 */}
                    <div className="mb-3">
                        <label className="fw-bold">Opinion</label>
                        <div>
                            <Input type="radio" name="approve" 
                                checked={approveOpinion === 'Approve'}
                                onChange={() => setApproveOpinion('Approve')}
                            /> Approve
                            <Input type="radio" name="approve" className="ms-3"
                                checked={approveOpinion === 'Refused'}
                                onChange={() => setApproveOpinion('Refused')}
                            /> Refused
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="fw-bold">Opinion Content</label>
                        <Input type="textarea" 
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="plase input your opinion content"
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setShowApproveModal(false)}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={handleSubmitApproval}>
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
};

export default NotificationDropdown;